module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grey-bg-sec"
  }, [_c('router-link', {
    attrs: {
      "to": '/login?url=' + _vm.isFirmOrder
    }
  }, [_c('div', {
    staticClass: "loginTips"
  }, [_c('ul', {
    staticClass: "edit-list"
  }, [_c('li', [_c('div', {
    staticClass: "edit-item"
  }, [_c('span', [_vm._v("如此前已购买过，可直接登录")]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-right"
  })])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "address-edit-sec"
  }, [_c('ul', {
    staticClass: "edit-list"
  }, [_c('li', [_c('div', {
    staticClass: "edit-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "收货人",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "edit-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "placeholder": "收货人手机"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "edit-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.area),
      expression: "area"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "收货城市",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.area)
    },
    on: {
      "click": function($event) {
        _vm.popupVisible = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.area = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-right"
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "edit-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "100",
      "placeholder": "详细地址，如街道、楼层、门牌号等"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "edit-list"
  }, [_c('li', [_c('div', {
    staticClass: "edit-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cusUser),
      expression: "cusUser"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "下单人",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.cusUser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cusUser = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "edit-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cusPhone),
      expression: "cusPhone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "placeholder": "下单人手机"
    },
    domProps: {
      "value": (_vm.cusPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cusPhone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "edit-item no-bor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "input code-input",
    attrs: {
      "type": "text",
      "placeholder": "短信验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    class: _vm.codeBtnClass,
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getVaildCode
    }
  }, [_vm._v(_vm._s(_vm.codeText))])])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn-save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.noLoginSave
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('mt-popup', {
    staticClass: "address-popup",
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.popupVisible),
      callback: function($$v) {
        _vm.popupVisible = $$v
      },
      expression: "popupVisible"
    }
  }, [_c('addressPick', {
    attrs: {
      "isOrderAddress": _vm.hasOwnDelivery
    },
    on: {
      "cancel": _vm.togglePopup,
      "submit": _vm.setAddressArea
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-bar"
  }, [_c('span', {
    staticClass: "icon-goback",
    attrs: {
      "onClick": "history.back();"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-title"
  }, [_c('span', {
    staticClass: "vt-middle"
  }, [_vm._v("新增地址")])]), _vm._v(" "), _c('span', {
    staticClass: "flex-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6300426e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/address/addressNologinAdd.vue
// module id = 575
// module chunks = 1